import React, { useState, useEffect, Fragment } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { register, clearAuthError } from '../../store/actions/authActions';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import Logo from '../../images/gattomioNero.png';
import paws8 from '../../images/paws-8.png';
import paws10 from '../../images/paws-10.png';
import '../LoginPage/AuthPage.scss';

const RegisterPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isAuthenticated, loading, error } = useSelector(state => state.auth);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    phone: '',
    address: '',
    city: '',
    zip: '',
    country: 'IT',
  });
  const [formErrors, setFormErrors] = useState({});
  const [acceptTerms, setAcceptTerms] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/checkout', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    dispatch(clearAuthError());
  }, [dispatch]);

  const validate = () => {
    const errors = {};
    if (!formData.name.trim()) errors.name = 'Nome obbligatorio';
    if (!formData.email) errors.email = 'Email obbligatoria';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email = 'Email non valida';
    if (!formData.password) errors.password = 'Password obbligatoria';
    else if (formData.password.length < 8) errors.password = 'Minimo 8 caratteri';
    if (formData.password !== formData.password_confirmation) {
      errors.password_confirmation = 'Le password non coincidono';
    }
    if (!acceptTerms) errors.terms = 'Devi accettare i termini e condizioni';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (formErrors[e.target.name]) {
      setFormErrors({ ...formErrors, [e.target.name]: '' });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      await dispatch(register({
        name: formData.name,
        email: formData.email,
        password: formData.password,
        password_confirmation: formData.password_confirmation,
        phone: formData.phone || undefined,
        address: formData.address || undefined,
        city: formData.city || undefined,
        zip: formData.zip || undefined,
        country: formData.country || 'IT',
      }));
    } catch (err) {
      // Errore gestito dal reducer
    }
  };

  return (
    <Fragment>
      <Navbar hclass={'wpo-site-header'} Logo={Logo} />
      <PageTitle pageTitle={'Registrati'} pagesub={'Register'} />

      <section className="wpo-auth-section section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">

              <div className="auth-wrapper">
                {/* Left decorative panel */}
                <div className="auth-side-panel">
                  <div className="side-panel-content">
                    <div className="side-panel-icon">
                      <img src={paws8} alt="Petlox paw" />
                    </div>
                    <h3>Unisciti alla famiglia Petlox!</h3>
                    <p>
                      Crea il tuo account per accedere a offerte esclusive,
                      tracciare i tuoi ordini e molto altro.
                    </p>
                    <Link to="/login" className="side-panel-btn">
                      Hai già un account? Accedi
                    </Link>
                  </div>
                </div>

                {/* Right form panel */}
                <div className="auth-form-panel">
                  <div className="auth-form-header">
                    <span className="auth-subtitle">Nuovo Account</span>
                    <h2>Registrati</h2>
                    <p>Compila i campi per creare il tuo account</p>
                  </div>

                  {error && (
                    <div className="auth-alert">
                      <span className="alert-icon">
                        <i className="ti-alert"></i>
                      </span>
                      <p>{error}</p>
                    </div>
                  )}

                  <form className="auth-form" onSubmit={handleSubmit} noValidate>
                    {/* Nome */}
                    <div className="form-group">
                      <label>Nome completo *</label>
                      <div className="input-wrapper">
                        <input
                          type="text"
                          name="name"
                          className={formErrors.name ? 'is-invalid' : ''}
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Mario Rossi"
                          autoComplete="name"
                        />
                        <i className="ti-user field-icon"></i>
                      </div>
                      {formErrors.name && <div className="invalid-feedback">{formErrors.name}</div>}
                    </div>

                    {/* Email */}
                    <div className="form-group">
                      <label>Email *</label>
                      <div className="input-wrapper">
                        <input
                          type="email"
                          name="email"
                          className={formErrors.email ? 'is-invalid' : ''}
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="la-tua@email.com"
                          autoComplete="email"
                        />
                        <i className="ti-email field-icon"></i>
                      </div>
                      {formErrors.email && <div className="invalid-feedback">{formErrors.email}</div>}
                    </div>

                    {/* Password + Conferma */}
                    <div className="form-row">
                      <div className="form-group">
                        <label>Password *</label>
                        <div className="input-wrapper">
                          <input
                            type="password"
                            name="password"
                            className={formErrors.password ? 'is-invalid' : ''}
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="Minimo 8 caratteri"
                            autoComplete="new-password"
                          />
                          <i className="ti-lock field-icon"></i>
                        </div>
                        {formErrors.password && <div className="invalid-feedback">{formErrors.password}</div>}
                      </div>
                      <div className="form-group">
                        <label>Conferma Password *</label>
                        <div className="input-wrapper">
                          <input
                            type="password"
                            name="password_confirmation"
                            className={formErrors.password_confirmation ? 'is-invalid' : ''}
                            value={formData.password_confirmation}
                            onChange={handleChange}
                            placeholder="Ripeti la password"
                            autoComplete="new-password"
                          />
                          <i className="ti-lock field-icon"></i>
                        </div>
                        {formErrors.password_confirmation && (
                          <div className="invalid-feedback">{formErrors.password_confirmation}</div>
                        )}
                      </div>
                    </div>

                    {/* Telefono */}
                    <div className="form-group">
                      <label>Telefono (opzionale)</label>
                      <div className="input-wrapper">
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="+39 333 1234567"
                          autoComplete="tel"
                        />
                        <i className="ti-mobile field-icon"></i>
                      </div>
                    </div>

                    {/* Sezione spedizione */}
                    <p className="form-section-label">Dati di spedizione (opzionali)</p>

                    {/* Indirizzo */}
                    <div className="form-group">
                      <label>Indirizzo</label>
                      <div className="input-wrapper">
                        <input
                          type="text"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          placeholder="Via Roma 123"
                          autoComplete="street-address"
                        />
                        <i className="ti-location-pin field-icon"></i>
                      </div>
                    </div>

                    {/* Città + CAP + Paese */}
                    <div className="form-row">
                      <div className="form-group">
                        <label>Città</label>
                        <div className="input-wrapper">
                          <input
                            type="text"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            placeholder="Milano"
                            autoComplete="address-level2"
                          />
                          <i className="ti-home field-icon"></i>
                        </div>
                      </div>
                      <div className="form-group">
                        <label>CAP</label>
                        <div className="input-wrapper">
                          <input
                            type="text"
                            name="zip"
                            value={formData.zip}
                            onChange={handleChange}
                            placeholder="20100"
                            autoComplete="postal-code"
                            maxLength="10"
                          />
                          <i className="ti-tag field-icon"></i>
                        </div>
                      </div>
                    </div>

                    {/* Paese */}
                    <div className="form-group">
                      <label>Paese</label>
                      <div className="input-wrapper">
                        <select
                          name="country"
                          value={formData.country}
                          onChange={handleChange}
                          autoComplete="country"
                        >
                          <option value="IT">Italia</option>
                          <option value="FR">Francia</option>
                          <option value="DE">Germania</option>
                          <option value="ES">Spagna</option>
                          <option value="CH">Svizzera</option>
                          <option value="AT">Austria</option>
                          <option value="BE">Belgio</option>
                          <option value="NL">Paesi Bassi</option>
                          <option value="GB">Regno Unito</option>
                          <option value="US">Stati Uniti</option>
                        </select>
                        <i className="ti-world field-icon"></i>
                      </div>
                    </div>

                    {/* Termini e condizioni */}
                    <div className="form-check-group">
                      <input
                        type="checkbox"
                        id="acceptTerms"
                        checked={acceptTerms}
                        onChange={(e) => {
                          setAcceptTerms(e.target.checked);
                          if (formErrors.terms) setFormErrors({ ...formErrors, terms: '' });
                        }}
                      />
                      <div>
                        <label htmlFor="acceptTerms">
                          Accetto i{' '}
                          <Link to="/terms" target="_blank">termini e condizioni</Link>
                          {' '}e la{' '}
                          <Link to="/privace" target="_blank">privacy policy</Link>
                        </label>
                        {formErrors.terms && <div className="invalid-feedback">{formErrors.terms}</div>}
                      </div>
                    </div>

                    <div className="submit-area">
                      <button
                        type="submit"
                        className="theme-btn"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Registrazione in corso...
                          </>
                        ) : 'Crea account'}
                      </button>
                    </div>
                  </form>

                  <div className="auth-divider">
                    <span>oppure</span>
                  </div>

                  <div className="auth-switch-link">
                    <p>
                      Hai già un account?{' '}
                      <Link to="/login">Accedi</Link>
                    </p>
                  </div>
                </div>
              </div>

              {/* Decorative paw images */}
              <img src={paws8} alt="" className="paw-decoration paw-top-right" />
              <img src={paws10} alt="" className="paw-decoration paw-bottom-left" />

            </div>
          </div>
        </div>
      </section>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default RegisterPage;
